var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFFFFF;stroke:#39526E;stroke-width:37.5;stroke-linecap:round;stroke-miterlimit:10;}\t.st1{fill:#3B506D;stroke:#39526E;stroke-width:50;stroke-miterlimit:10;}\t.st2{fill:none;stroke:#39526E;stroke-width:50;stroke-miterlimit:10;}\t.st3{fill:none;stroke:#EEA320;stroke-width:50;stroke-linecap:square;stroke-miterlimit:10;}\t.st4{fill:#3B506D;stroke:#39526E;stroke-width:38.6718;stroke-miterlimit:10;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1201,1448.7H306.7c-139.4,0-253.5-114.1-253.5-253.5V300.8c0-139.4,114.1-253.5,253.5-253.5H1201  c139.4,0,253.5,114.1,253.5,253.5v894.4C1454.6,1334.6,1340.5,1448.7,1201,1448.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1136,789.6 1036.8,846.7 1036.9,732.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 456,
    y1: 787.5,
    x2: 1027.9,
    y2: 787.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "387,788.7 486.1,846.1 486.2,731.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1246.6,
    y1: 447.6,
    x2: 1246.6,
    y2: 588.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1246.5,
    y1: 439.7,
    x2: 878,
    y2: 439.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 265.5,
    y1: 447.6,
    x2: 265.5,
    y2: 588.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 265.6,
    y1: 439.7,
    x2: 634.1,
    y2: 439.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1246.6,
    y1: 1118,
    x2: 1246.6,
    y2: 977.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 1246.5,
    y1: 1125.9,
    x2: 878,
    y2: 1125.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 265.5,
    y1: 1118,
    x2: 265.5,
    y2: 977.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 265.6,
    y1: 1125.9,
    x2: 634.1,
    y2: 1125.9
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "762,489.6 819.1,588.8 704.6,588.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 759.9,
    y1: 1032.4,
    x2: 759.9,
    y2: 519.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "761.1,1063.6 818.5,964.5 703.9,964.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.1a1d1f5d4932a3fe09d6b3005b6596dc.svg";
export { ForwardRef as ReactComponent };